import { QueueStatus } from 'types';

import { ReviewPackageActions } from '../../types/ReviewPackage';

export function validateWarranties({
  isFinCoUser,
  action,
  warrantiesConfirmed,
  targetStatus,
}: {
  isFinCoUser: boolean;
  action: ReviewPackageActions | undefined;
  warrantiesConfirmed: boolean;
  targetStatus?: QueueStatus;
}): void {
  if (
    isFinCoUser &&
    action === ReviewPackageActions.review &&
    targetStatus &&
    [QueueStatus.approved, QueueStatus.conditionallyApproved].includes(targetStatus) &&
    !warrantiesConfirmed
  ) {
    const validationError = new Error('Warranty registration confirmation is required before approving');
    validationError.name = 'ValidationError';
    throw validationError;
  }
}
